import { lazyPage } from '@/lib/lazy-load'

const MyOrganizationsPage = lazyPage(() => import('./MyOrganizationsPage'))
export default MyOrganizationsPage
